import React, { useState, useEffect } from 'react'

import queryString from 'query-string'

import Loader from 'react-loader-spinner'
import Layout from '../../components/Layout/Default'

import ChallengeItem from '../../components/Challenge/Item'
import ChallengeCategory from '../../components/Challenge/Category'
import ChallengeDetails from '../../components/Challenge/Details'

import reddit from '../../assets/img/reddit.png'

import { Container, Categories, Info, List, NoChallenges, Details, Reddit } from './styles.js'

import api from '../../services/api'

function Challenges(){
  //React States
  const [ loader, setLoader ] = useState(false)

  const [ options, setOptions ] = useState([])
  const [ currentOption, setCurrentOption ] = useState("daily")

  const [ challenges, setChallenges ] = useState({ quick:[], daily: [], weekly: [], themed: [], pro: [] })
  const [ doneChallenges, setDoneChallenges ] = useState({ quick:[], daily: [], weekly: [], themed: [], pro: [] })
  const [ currentChallenge, setCurrentChallenge ] = useState(0)

  //Constants
  const texts =  {
    daily: "Daily Challenges", 
    weekly: "Weekly Challenges", 
    themed: "Themed Challenges", 
    pro: "Pro Challenges",
    quick: "Quick Challenges"
  }

  //Get date in UTC
  async function getDate(){
    const time = new Date().setUTCHours(0,0,0,0)
    return new Date(time).toISOString()
  }

  //Get a challenge List by type
  async function getChallengesByType(type, query){
    const params = queryString.stringify(query)

    const list = await api.get(`/challenges/${type}?${params}`)
    let result = []
    if(list.data[0]){
      result = list.data[0].challenges
    }
    return result
  }

  //Update Challenge Lists
  async function updateChallenges(){
    const season = process.env.REACT_APP_SEASON || 3
    const date = await getDate()

    const daily = await getChallengesByType('daily', { date })
    const weekly = await getChallengesByType('weekly', { date })

    const themed = await getChallengesByType('themed', { season })
    const pro = await getChallengesByType('pro', { season })

    const quick = await getChallengesByType('quick', { date })
    
    const challengeList = { daily, weekly, themed, pro, quick }

    setChallenges(challengeList)
  }

  async function getDoneChallenges(){
    const date = await getDate()

    const daily = JSON.parse(localStorage.getItem(`daily-challenges`))
    const weekly = JSON.parse(localStorage.getItem(`weekly-challenges`))
    const themed = JSON.parse(localStorage.getItem(`themed-challenges`))
    const pro = JSON.parse(localStorage.getItem(`pro-challenges`))
    const quick = JSON.parse(localStorage.getItem(`quick-challenges-${date}`))

    const done = { 
      daily: daily ? daily : [], 
      weekly: weekly ? weekly : [], 
      themed: themed ? themed : [], 
      pro: pro ? pro : [], 
      quick: quick ? quick : [] 
    }

    if(done){
      await setDoneChallenges(done)
    }
    setLoader(false)
  }

  //Filter completed
  function countCompleted(type){
    return challenges[type].filter((challenge) => doneChallenges[type].includes(challenge._id))
  }
  //Count completed challenges
  async function countChallenges(){
    const count = {
      daily: { 
        total: challenges.daily.length,
        completed: countCompleted("daily").length
      },
      weekly: { 
        total: challenges.weekly.length,
        completed: countCompleted("weekly").length
      },
      themed: { 
        total: challenges.themed.length,
        completed: countCompleted("themed").length
      },
      pro: { 
        total: challenges.pro.length,
        completed: countCompleted("pro").length
      },
      quick: { 
        total: Object.keys(challenges.quick).length,
        completed: countCompleted("quick").length
      },
    }
    
    setOptions([
      { completed: count.daily.completed, total: count.daily.total, text: "Daily Challenges", type: "daily" },
      { completed: count.weekly.completed, total: count.weekly.total, text: "Weekly Challenges", type: "weekly" },
      { completed: count.themed.completed, total: count.themed.total, text: "Themed Challenges", type: "themed"  },
      { completed: count.pro.completed, total: count.pro.total, text: "Pro Challenges", type: "pro" },
      { completed: count.quick.completed, total: count.quick.total, text: "Quick Challenges", type: "quick" },
    ])
  }

  //Change current challenge list
  async function changeChallengeList(option) {
    await setCurrentOption(option)
    await setCurrentChallenge(0)
    countChallenges()
    setLoader(false)
  }

  //Change current challenge
  async function changeSelectedChallenge(challenge){
    await setCurrentChallenge(challenge)
  }

  //Change if challenge was done or not
  async function updateDoneChallenges(e, id){
    // e.stopPropagation()
    let done = doneChallenges

    if(doneChallenges[currentOption].includes(id)){
      done[currentOption] = doneChallenges[currentOption].filter(challenge => challenge !== id)
    } else {
      done[currentOption] = [ ...doneChallenges[currentOption], id ]
    }

    if(currentOption === 'quick'){
      const date = await getDate()
      localStorage.setItem(`${currentOption}-challenges-${date}`, JSON.stringify(done[currentOption]))
    } else {
      localStorage.setItem(`${currentOption}-challenges`, JSON.stringify(done[currentOption]))
    }
    setDoneChallenges({ ...done })
  }

  function saveToReddit() {

    let redditTable = '|Challenge|Task|Nitro Points|\n|:-|:-|:-|'
    challenges[currentOption].map((challenge) => {
      redditTable += `\n|**${challenge.name}**|${challenge.desc}|${challenge.reward}|`
    })

    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(redditTable));
    element.setAttribute('download', `${currentOption}Reddit`);

    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  useEffect(() => {
    updateChallenges()
    getDoneChallenges()
  }, [])

  useEffect(() => {
    countChallenges()
  }, [challenges, doneChallenges])

  function renderChallengeList(){
    return (
      <Info>
        <List>
          { challenges[currentOption].map((challenge, index) => (
            <ChallengeItem
              key= { index }
              changeChallenge={() => changeSelectedChallenge(index)}
              checkChallenge={(e) => updateDoneChallenges(e, challenge._id) }
              completed={ doneChallenges[currentOption].includes(challenge._id) }
              selected={ index === currentChallenge ? true : false }
              text={ challenge.name }
            />
          ))}
        </List>
        <Details>
          { challenges[currentOption][currentChallenge] !== undefined ? (
            <ChallengeDetails
              desc={ challenges[currentOption][currentChallenge].desc }
              reward={ challenges[currentOption][currentChallenge].reward }
            />
            ): ''}
        </Details>
        <Reddit src={reddit} onClick={() => saveToReddit()}/>
      </Info>
    )
  }

  function renderNoChallenges(){
    return (
      <NoChallenges>{ `No ${texts[currentOption]} registered for today yet` }</NoChallenges>
    )
  }
  
  function renderLayout(){
    return (
      <Container>
        <Categories>
          { options.map((option, index) => (
            <ChallengeCategory
              key= {index}
              event={() => changeChallengeList(option.type)}
              selected={ currentOption === option.type }
              current={ option.completed }
              type={ option.type }
              total={ option.total }
              text={ option.text }
            />
          ))}
        </Categories>
        { (challenges[currentOption].length > 0 ? renderChallengeList() : renderNoChallenges()) }
      </Container>
    )
  }

  function renderLoader(){
    return(
      <Loader 
        type="Circles"
        color="#FFF"
        height="100"	
        width="100"
      />   
    )
  }

  return (
    <Layout selected="challenges">
      { loader ? renderLoader() : renderLayout() }
    </Layout>
  )
}

export default Challenges